import React, { useRef } from "react";
import _ from "lodash";
import ResultList from "./ResultList";

const Result = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const changedDataCount = props.data.filter( ( v, i ) => ! _.isEqual( prevData.current[ i ], v ) ).length;

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = props.data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  const LIST = props.data.map( ( v, i ) => <ResultList key={ i } index={ i } type={ props.type } data={ v } onRender={ renderMathJax } /> );

  return (
    <table className="tbl_number_box viewer">
      <tbody>
      <tr>{ LIST }</tr>
      </tbody>
    </table>
  );

};

export default Result;
